import React from 'react';
import { navigate } from 'gatsby';
import Container from '../General/Container';
import Text from '../General/Text';
import Button from '../General/Button';
import {
  WrapperStyled,
  BlocksStyled,
  SvgHeaderWrapperStyled,
  ItemBlockStyled,
  ParItemBlockStyled,
} from './styles/HomeLinkBlockStyled';
import {
  ManageText,
  ConsumedIcon,
  InvoicesIcon,
  PlanIcon,
  MarketIcon,
} from '../../images/consejos-bam';

const HomeLinkBlock = () => {
  return (
    <WrapperStyled>
      <SvgHeaderWrapperStyled>
        <ManageText />
      </SvgHeaderWrapperStyled>
      <Container padding="0px" boxShadow="none">
        <Text
          size="18px"
          weight="400"
          color="#0E141D"
          align="center"
          lineHeight="20px"
          margin="0px auto 32px"
          text="Es muy fácil, revisa lo que puedes hacer a continuación:"
        />
        <BlocksStyled>
          <ParItemBlockStyled>
            <ItemBlockStyled>
              <ConsumedIcon />
              <Text
                size="18px"
                weight="700"
                color="#0E141D"
                lineHeight="20px"
                text="Ver tu consumo"
              />
            </ItemBlockStyled>
            <ItemBlockStyled>
              <PlanIcon />
              <Text
                size="18px"
                weight="700"
                color="#0E141D"
                lineHeight="20px"
                text="Ver tu plan"
              />
            </ItemBlockStyled>
          </ParItemBlockStyled>
          <ParItemBlockStyled>
            <ItemBlockStyled>
              <InvoicesIcon />
              <Text
                size="18px"
                weight="700"
                color="#0E141D"
                lineHeight="20px"
                text="Ver boletas"
              />
            </ItemBlockStyled>
            <ItemBlockStyled>
              <MarketIcon />
              <Text
                size="18px"
                weight="700"
                color="#0E141D"
                lineHeight="20px"
                text="Tienda"
              />
            </ItemBlockStyled>
          </ParItemBlockStyled>
        </BlocksStyled>
        <Text
          size="18px"
          weight="400"
          color="#0E141D"
          lineHeight="20px"
          text="¡y muchas cosas más!"
          margin="0px 0px 32px"
        />
        <Button
          color="bubbleGum"
          width="276px"
          click={() => navigate('/home')}
          margin="0px"
        >
          IR AL INICIO DE MIWOM
        </Button>
      </Container>
    </WrapperStyled>
  );
};

export default HomeLinkBlock;
